import React from 'react';
import styles from '../summary.module.scss';

const SubscriptionOverlay = () => (
  <div className={styles.premiumOverlay}>
    <div className={styles.premiumCard}>
      <div className={styles.premiumBadge}>PRO</div>
      <h2 className={styles.premiumTitle}>Desbloquea Reportes Avanzados</h2>
      <p className={styles.premiumDesc}>
        Analiza ventas por cliente y producto, identifica tendencias y optimiza tu
        negocio. Disponible en planes <strong>Pro</strong> y <strong>Enterprise</strong>.
      </p>
      <a
        href="https://wa.me/593968652005?text=Hola%2C%20me%20interesa%20acceder%20a%20los%20reportes%20de%20Cado"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.premiumCta}
      >
        Contactar para activar
      </a>
      <span className={styles.premiumHint}>
        Escríbenos a soporte para más información
      </span>
    </div>
  </div>
);

export default SubscriptionOverlay;
